import { AuthWrapper } from '@yubi/yb-module-auth';
import useIsPublicRoute from 'components/hooks/useIsPublicRoute';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './assets/fonts/icons/style.css';
import AppRouter from './router';

function App() {
    const navigate = useNavigate();
    const isPublicRoute = useIsPublicRoute();

    const orgDetails = useMemo(() => {
        return {
            ...(process.env.REACT_APP_ORG_LOGO
                ? {
                      imagePayload: {
                          src: `${process.env.REACT_APP_ORG_LOGO}`,
                          width: '180px',
                      },
                  }
                : {}),

            ...(process.env.REACT_APP_LOGIN_PAGE_TEXT
                ? {
                      loginPageText: process.env.REACT_APP_LOGIN_PAGE_TEXT,
                  }
                : {}),

            ...(process.env.REACT_APP_DISAPLE_WELCOME_TEXT
                ? {
                      disableWelcomeText:
                          process.env.REACT_APP_DISAPLE_WELCOME_TEXT === 'true' ? true : false,
                  }
                : {}),
        };
    }, []);

    return (
        <>
            {isPublicRoute ? (
                <AppRouter />
            ) : (
                <>
                    <AuthWrapper navigator={navigate} organizationDetails={orgDetails}>
                        <AppRouter />
                    </AuthWrapper>
                </>
            )}
        </>
    );
}

export default App;
